var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUploadCloudLg = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 21,
  viewBox: "0 0 32 21",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M22.5 19v2h-12v-2zM16 0c3.808 0 7.142 2.027 8.983 5.06a8 8 0 0 1 .518 15.798v-2.049a6 6 0 0 0-1.752-11.805 8.5 8.5 0 0 0-16.211 4.302 4 4 0 1 0-2.038 7.66V19h2v2h-2v-.02a6 6 0 0 1 .105-11.966C6.327 3.918 10.705 0 16 0m1.414 9h.086l2.731 2.857.707.707-1.414 1.414-2.024-2.024v5.07h-2v-5.061l-1.293 1.293-.707.707-1.414-1.414.707-.707L15.5 9z"
})));
export default SvgUploadCloudLg;